import { Demand } from "../../../../assets/svg-icons";

export const DSAI = {
    name: "Demand Sensing",
    route: "/ds/forecast",
    shortName: "Demand",
    icon: Demand,
    permissions: ["DEMAND_SENSING_VIEW"],
};
